(function(){

  //ナビクリック
  const $menu = {
    file: "./menu.json",
    nav: document.querySelector('.js-ft-Menu__nav'),
    item: document.querySelectorAll('.js-ft-Menu__nav li a'),
    detail: document.querySelector('.js-ft-Menu__detail'),
    detailTitle: document.querySelector('.js-ft-Menu__detailTitle'),
    textTitle: document.querySelector('.js-ft-Menu__detailTextTitle'),
    textDescription: document.querySelector('.js-ft-Menu__detailTextDescription'),
  }

  var preload_images = [
    'https://clannbytheriver.jp/wp-content/themes/clann_v1/img/menu_bg_breakfast.jpg',
    'https://clannbytheriver.jp/wp-content/themes/clann_v1/img/menu_bg_lunch.jpg',
    'https://clannbytheriver.jp/wp-content/themes/clann_v1/img/menu_bg_dinner.jpg',
    'https://clannbytheriver.jp/wp-content/themes/clann_v1/img/menu_bg_course.jpg'
  ];

  document.addEventListener('DOMContentLoaded', function(){
    for (var i = 0; i < preload_images.length; i++) {
        var img = new Image();
        img.src = preload_images[i];
    }
  });

  let len = $menu.item.length;
  let currentName;

  // JOSNデータ取得
  let xhr = new XMLHttpRequest();
  xhr.open("GET", '/wp-content/themes/clann_v1/script/menu.json?ver=0002');
  xhr.responseType = "json";
  xhr.send();

  // メニュー初期値
  xhr.onload = function() {
    var defaultNav = 'breakfast';
    xmlhttp(defaultNav);
  };

  function xmlhttp(e) {

    let data = xhr.response;

    if (xhr.readyState === 4) {
      if (xhr.status === 200) {

        let title = data[e].title;
        let textHead = data[e].textHead;
        let textBody = data[e].textBody;

        $menu.detailTitle.innerHTML = title;
        $menu.textTitle.innerHTML = textHead;
        $menu.textDescription.innerHTML = textBody;

      } else {
        console.log("status = " + xhr.status);
      }
    }
  }


  //要素チェンジ

  function elementChange() {

    // 画像取得
    let $image = document.querySelector('.js-ft-Menu__image');
    let $imageItem = document.querySelector('.js-ft-Menu__imageItem');

    // テキスト非表示
    $menu.detail.classList.add('is-hide');

      // カレント画像セット
      let newElement = document.createElement('div');
      newElement.classList.add('ft-Menu__imageItem');
      newElement.classList.add('js-ft-Menu__imageItem');
      newElement.style.backgroundImage = 'url(/wp-content/themes/clann_v1/img/menu_bg_' + currentName + '.jpg?v=2023)';

      // カレント画像追加
      $image.insertBefore(newElement, $image.children[0]);

    // 画像非表示
    setTimeout(function(){
      $imageItem.classList.add('is-hide');

      // テキスト書き換え
      $menu.detail.addEventListener('transitionend', function(){
        xmlhttp(currentName);
      });

      // テキスト表示
      $imageItem.addEventListener('transitionend', function(){
        $menu.detail.classList.remove('is-hide');
      });

      //要素削除
      $imageItem.addEventListener('transitionend', function(){
        $image.removeChild($image.children[1]);
      });

    }, 10);

  }

  // アクション

  for(let i = 0; i < len; i++) {
    $menu.item[i].addEventListener('click', function(){
      for(let i = 0; i < len; i++) {
        // class削除
        $menu.item[i].classList.remove('is-current');
      }

      // class付与
      this.classList.add('is-current');

      // ナビゲーションカレントセット
      //データセット取得
      currentName = this.dataset.title;

      // テキスト変更
      elementChange();

    });
  }
}());